import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import {
  salesQuestionService,
  type SalesQuestion,
} from "@/app/services/generated/salesquestionService";

export interface IHasSalesQuestionsCache {
  salesQuestions: SalesQuestionsCache;
}
// Singleton cache store
const cacheStore = new EntityCacheStore<SalesQuestion>(
  EnumCacheEntityType.salesQuestion,
  async () => salesQuestionService.getAllSalesQuestions()
);

// Ephemeral reader
export default class SalesQuestionsCache extends EntityWithGuidKeyCache<SalesQuestion> {
  constructor() {
    super(cacheStore, (x) => x.id);
  }
}
